import React from "react";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";

const AfterEvalUser = ({ setIrModal, completeRate, investInfo, info, showCommentary }) => {
	const { t } = useTranslation();

	const [
		{
			sidebar: { currentPath },
			theme: { theme },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	return (
		<>
			<section className="c__card evaluate-card judge-card">
				<div className="content">
					<h5 className="percent">
						{Number.isInteger(completeRate)
							? completeRate
							: parseFloat(completeRate).toFixed(2)}
						<i>%</i>
					</h5>
					{completeRate === 100 ? (
						<>
							<p className="main">
								{t(
									"pages.investment.InvestEvalPage.detail.Step.cardForJudge.alert01.main"
								)}
							</p>
							<p className="sub">
								{t(
									"pages.investment.InvestEvalPage.detail.Step.cardForJudge.alert01.sub"
								)}
							</p>
						</>
					) : (
						<>
							<p className="main">
								{t(
									"pages.investment.InvestEvalPage.detail.Step.cardForJudge.alert02.main"
								)}
							</p>
							<p className="sub">
								{t(
									"pages.investment.InvestEvalPage.detail.Step.cardForJudge.alert02.sub1"
								)}
							</p>
						</>
					)}
					<div className="btn-wrap">
						<button
							type="button"
							className="btn__solid"
							color="gray"
							onClick={() => {
								if (currentPath.auth !== "edit") {
									showAuthAlert();
									return;
								}
								setIrModal(true);
							}}
						>
							{t("pages.investment.InvestEvalPage.detail.Step.cardForJudge.button01")}
						</button>
						<button
							type="button"
							className="btn__solid"
							color="primary"
							disabled={parseInt(completeRate) === 0}
							onClick={() => {
								if (currentPath.auth !== "edit") {
									showAuthAlert();
									return;
								}
								showCommentary(true, info.idx);
							}}
						>
							{t("pages.investment.InvestEvalPage.detail.Step.cardForJudge.button03")}
						</button>
					</div>
				</div>
				<ul className="judge-list">
					{investInfo?.Judge?.map((d) => (
						<li
							key={d.idx}
							className={d.Score.length > 0 ? "complete" : "waiting"}
							onClick={() =>
								d.Score.length === 0
									? ""
									: d.userIdx === info.idx
									? showCommentary(true, d.userIdx)
									: ""
							}
						>
							<img
								src={
									d.VcUser.img ||
									(theme === "dark"
										? DarkDefaultProfileImg
										: LightDefaultProfileImg)
								}
								alt={t(
									"pages.investment.InvestEvalPage.detail.Step.cardForJudge.imageAlt"
								)}
							/>
							{/*<img src={d.VcUser.img || lightProfileImg} alt="심사역" />*/}
						</li>
					))}
				</ul>
			</section>
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</>
	);
};

export default AfterEvalUser;
